module.exports = __webpack_public_path__ + "img/lacoustics_logo.a73b3488.svg";